<template>
  <va-create-layout>
    <model-form :title="title" :item="item"></model-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"]
};
</script>
